import { ReactElement, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSearchStore } from '../../../../store/search/SearchStore'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { AutoCheckImage } from '../../../../ui-components/AutoCheckImage'
import { VehicleSelector } from './VehicleSelector'
import {
  useVehicleWidgetStore,
  VehicleWidgetDisplayState,
  VehicleWidgetStore,
} from '../store/VehicleWidgetStore'
import { VehicleQuickFind } from './VehicleQuickFind/index'
import { VehicleSelectorStep } from '../../../../ui-components/util/Interfaces'
import { breakpoints } from '../../../../theme/breakpoints'
import { useUiStateStore } from 'src/store/uiState/UiStateStore'

export const YMMESelector = observer((): ReactElement => {
  const navigate = useNavigate()
  const vehicleWidgetStore = useVehicleWidgetStore()
  const { currentVehicle } = useSearchStore()
  const [selectorStartStep, setSelectorStartStep] =
    useState<VehicleSelectorStep>(
      VehicleWidgetStore.getActiveVehicleStep(currentVehicle)
    )

  const { isAutoCheckEnabled } = useUiStateStore()

  const handleVehicleSelected = useCallback(() => {
    vehicleWidgetStore.setIsDrawerOpened(false)
    vehicleWidgetStore.setDisplayState(VehicleWidgetDisplayState.view)
    const afterAddVehicleCallback = vehicleWidgetStore.afterAddVehicle()
    if (!afterAddVehicleCallback) {
      navigate('/partsCatalog')
    } else {
      afterAddVehicleCallback()
      vehicleWidgetStore.setAfterAddVehicle(undefined)
    }
  }, [navigate, vehicleWidgetStore])

  useEffect(() => {
    setSelectorStartStep(
      VehicleWidgetStore.getActiveVehicleStep(currentVehicle)
    )
  }, [currentVehicle])

  return (
    <Wrapper>
      <TopRow>
        <VehicleQuickFindWrapper>
          <VehicleQuickFind
            onVehicleSelected={handleVehicleSelected}
            vehicleLookup={true}
          />
        </VehicleQuickFindWrapper>

        {isAutoCheckEnabled() && (
          <AutoCheckImage vin={currentVehicle.vin} size="medium" />
        )}
      </TopRow>

      <VehicleSelectorWrapper>
        <VehicleSelector
          onVehicleSelected={handleVehicleSelected}
          startStep={selectorStartStep}
        />
      </VehicleSelectorWrapper>
    </Wrapper>
  )
})

const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 0px 0px 0px;
  gap: 20px;
  width: 100%;
  font-family: Roboto, serif;
`

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

const VehicleQuickFindWrapper = styled.div`
  width: 378px;
  flex-shrink: 0;
`

const VehicleSelectorWrapper = styled.div`
  @media screen and (width > ${breakpoints.laptopXLarge}px) {
    width: 1614px;
  }

  @media screen and (${breakpoints.laptopLarge}px < width <= ${breakpoints.laptopXLarge}px) {
    min-width: 1255px;
    max-width: 1614px;
  }

  @media screen and (${breakpoints.laptopMedium}px < width <= ${breakpoints.laptopLarge}px) {
    min-width: 1231px;
    max-width: 1255px;
  }

  @media screen and (${breakpoints.laptop}px < width <= ${breakpoints.laptopMedium}px) {
    width: 100%;
  }
`
